import * as angular from 'angular';

// **************************************************************************************************
// You MUST include floatThead (http://mkoryak.github.io/floatThead/) for this directive to work!
// <script src="../js/components/floatThead/dist/jquery.floatThead.js"></script>
// **************************************************************************************************

// Given a directive like this in the HTML:
// <div class="fixedHeaderWrapper">
//   <table fixed-header>
//     <colgroup>
//       <col class="col1">
//       <col class="col2">
//       ...
//     </colgroup>
//     <thead>
//       ...
//     </thead>
//     <tbody>
//       ...
//     </tbody>
//   </table>
// </div>
//
// or this (if you just want a fixed header on the page and you don't need to constrain it to within a fixed space):
//
// <table fixed-header>
//   <colgroup>
//     <col class="col1">
//     <col class="col2">
//     ...
//   </colgroup>
//   <thead>
//     ...
//   </thead>
//   <tbody>
//     ...
//   </tbody>
// </table>
//
// If the table we want to fix is not visible initially then we can use the reflow attribute to let the directive know
// when it becomes visible. The directive will relocate the fixed header so it's at the correct position then:
//   <table fixed-header reflow="trueWhenVisibleFunction()">
//
// Unfortunately, if the area where the table is animates into visibility (for example, the details section on the
// Offer Impact page which takes 350ms to animate on) we need to delay the reflow for long enough for the animation to
// finish.
//   <table fixed-header reflow="trueWhenVisibleFunction()" reflow-delay="500">
//
// Note: Usually the above is paired with some simple styling like this if you're floating within a constrained area
// (shown in SCSS form):
//   .fixedHeaderWrapper {
//     height: 388px;
//     overflow: auto;
//
//     thead {
//       background-color: white;
//     }
//   }
//
// or this if you're just constraining to the page as a whole:
//   thead {
//     background-color: white;
//   }
//
// Note: I really encourage the use of the colgroup and col elements because they will help you align your columns and
// the floating header will not cause them to change widths. Without this I've had frequent problems with column width
// on tables with fixed headers.
export default function ($timeout, $log) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      reflow: '=',
      reflowDelay: '=',
      absolutePositioning: '='
    },
    link: function ($scope, $element, $attrs) {
      var table: any = $($element);
      var wrapper = table.closest('.fixedHeaderWrapper');
      var useAbsolutePositioning = $scope.absolutePositioning;

      // If the user did not provide a setting for absolute positioning, assume false.
      if (!('absolutePositioning' in $attrs)) {
        useAbsolutePositioning = false;
      }

      var options: any = {
        useAbsolutePositioning: useAbsolutePositioning
      };

      // If there's a parent element marked with the fixedHeaderWrapper class then we'll indicate to floatThead that it
      // should constrain the scrolling to that parent element. Note: You have to use the overflow and height as
      // mentioned above.
      if (wrapper.length === 1) {
        options.scrollContainer = function ($table) {
          return wrapper;
        };
      }

      table.floatThead(options);

      // If and only if they've given us an AngularJS expression which will tell us when to reflow do we setup to watch
      // that reflow expression and trigger reflows when it is true.
      if (angular.isDefined($attrs.reflow)) {
        $scope.$watch('reflow', function (newValue, oldValue) {
          // Now we're going to reflow after a specified timeout. I found this to be necessary because I used
          // animations on the Offer Impact page when a details section is revealed and if the reflow is triggered
          // before the facilities list visible then it doesn't work right.
          var delay = $scope.reflowDelay || 0;

          $timeout(function () {
            ($('.facilitiesInner table') as any).floatThead('reflow');
          }, delay);
        });
      }
    }
  };
}
